<!-- <p>bulk-login-and-share-and-addtostoryboard-container works!</p> -->
<div class="bulk_login_and_addstory_cont">
	<!-- <div class="bulk_login_button">
		<div class="bulklogincont">
			<p> LOG IN FOR BULK PRICE </p>
			<span class="material-symbols-outlined">
				person
			</span>
		</div>
	</div> -->
	<div class="volume_discount_button"  *ngIf="isLoggedIn">
		<button (click)="tempopenVOlumeDiscount()" >
			<ng-container *ngIf="product.productGroup === 'fabric' && !product.fabricProfileEnabled">Bulk Order &#64; {{bulkDiscountPrice | currencyConverter | number: '1.0-2'}} / {{product.unit}}</ng-container>
			<ng-container *ngIf="(product.productGroup !== 'fabric') || product.fabricProfileEnabled">Bulk Discount Available</ng-container>
			<span class="close material-symbols-outlined info_icon">info</span>
		</button>
	</div>
	<div  class="login_for_bulk_price" *ngIf="!isLoggedIn" [routerLink]="['../../../auth/login']"   (click)="storeUrl()">
		<p>Login For Bulk Price</p>
		<span  class="material-symbols-outlined"> person </span>
	</div>
	<div class="">
		<div (click)="toggleWishlist()" class="flex flex-col justify-center items-center cursor-pointer">
			<div class="">
				<img class="w-[35px] " src="assets/img/storyboard.svg" [alt]="product.name">
			</div>
			<div class="text-xs mt-1">{{inWishlist? 'REMOVE FROM': 'ADD TO'}} WISHLIST</div>
		</div>
<!--		<div class="share-wrapper">-->
<!--			<div class="share-btn" (click)="shareOpoupTriger()">-->
<!--				<span class="material-symbols-outlined">-->
<!--					share-->
<!--				</span>-->
<!--			</div>-->
<!--			<div class="share-btn-txt">Share</div>-->
<!--			<div class="share_cont_wrapper">-->
<!--				<fb-share-product *ngIf="sharePopup" (closeModalPopup)="closeShareModal()"></fb-share-product>-->
<!--			</div>-->

<!--		</div>-->
	</div>
</div>
